export default () => {
    document.querySelectorAll('[portal]').forEach(el => {
		const selector = el.getAttribute('portal')
		const target = document.querySelector(`[portal-target="${el.getAttribute('portal')}"`);

		if (!target) return;

        if (target.closest('.modal')) {
            $(target.closest('.modal')).on('show.bs.modal', () => {
                target.appendChild(el.content);
            });
        } else {
            target.appendChild(el.content);
        }
	});
}